import { ProductTypeEnum, StoreItemEnum } from '@systemeio/digital-store-shared'
import { StoreTabEnum } from 'modules/stores/store/enum/store-tab-enum'
import { StoreId } from 'modules/stores/types/stores-interface'
import { useRouter } from 'next/router'

const BASE_HREF = `/stores`

export const useStoreQuery = () => {
  const { query, push } = useRouter()
  const tab = query.tab as StoreTabEnum | undefined
  const productType = query.productType as ProductTypeEnum | undefined
  const itemRawId = query.item as StoreItemEnum | undefined
  const itemId = itemRawId ? (parseInt(itemRawId) as number) : undefined

  const storeId = query.storeId as StoreId | undefined
  const baseStoreHref = `${BASE_HREF}/${storeId || ''}`

  const redirectToMainPage = () => push({ query: { storeId } })

  const onChangeTab = (tab: StoreTabEnum) => push({ query: { storeId, tab } })

  const onCreateItem = (tab: StoreTabEnum, productType?: ProductTypeEnum) =>
    push({ query: productType ? { storeId, tab, productType } : { storeId, tab } })

  const onEditItem = (itemId: number, tab: StoreTabEnum, productType?: ProductTypeEnum) =>
    push({
      query: productType
        ? { storeId, tab, item: itemId, productType }
        : { storeId, tab, item: itemId },
    })

  return {
    tab,
    productType,
    storeId,
    itemId,
    BASE_HREF,
    baseStoreHref,
    onChangeTab,
    onCreateItem,
    onEditItem,
    redirectToMainPage,
  }
}
